import React,{Component} from 'react';
import {Card,CardBody} from 'reactstrap';

class EngagementChoiceInputContainer extends Component {
  render(){
    return (
      <Card className='NoBoxShadow EngagementChoiceInputContainer'>
        <CardBody>
          {this.props.children}
        </CardBody>
      </Card>
    )
  }
}


export default EngagementChoiceInputContainer;


// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/components/EngagementChoiceInputContainer.js